import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import _ from 'lodash';

class LargeCard extends React.Component {
    render() {
        const title = _.isString(this.props.title)
            ? this.props.title
            : [this.props.title[0], <span key={1}>{this.props.title[1]}</span>];
        const divider = <hr className="divider" />;
        if (this.props.type === 'card-edit') {
            return (
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <div className={'card level-1 ' + this.props.type}>
                            <div className="card-content">
                                <div className="card-desc">
                                    <h3
                                        className="headline1"
                                        data-testid={this.props.testId}
                                    >
                                        {' '}
                                        {title}{' '}
                                    </h3>
                                    {divider}
                                    {this.props.description}
                                </div>
                                {this.props.children}
                            </div>
                        </div>
                    </Col>
                </Row>
            );
        } else {
            return (
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <div className={'card level-1 ' + this.props.type}>
                            <div className="card-content">
                                <h2
                                    className="headline1"
                                    data-testid={this.props.testId}
                                >
                                    {' '}
                                    {title}{' '}
                                </h2>
                                {divider}
                                {this.props.children}
                            </div>
                        </div>
                    </Col>
                </Row>
            );
        }
    }
}

LargeCard.defaultProps = {
    title: 'Title',
    type: 'clickbox',
    children: undefined,
    testId: undefined,
};

LargeCard.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    type: PropTypes.oneOf([
        'clickbox',
        'card-info',
        'card-edit',
        'no-card-footer',
    ]).isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    children: PropTypes.node,
    testId: PropTypes.string,
};

export default LargeCard;
